import { format } from "date-fns";
import { EPatternUnit } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

export default (
  billingCycle: EPatternUnit,
  range: {
    start: { date: string; time: string | null };
    end: { date: string; time: string | null };
  }
) => {
  const formatDate = (date: string) => format(new Date(date), "dd.MM.yyyy");
  const formatTime = (time: string | null) =>
    time ? format(new Date(`2000-01-01T${time}`), "HH:mm") : "";

  if (billingCycle === EPatternUnit.Day) {
    let info = formatDate(range.start.date);
    if (range.end.date !== range.start.date) {
      info += ` - ${formatDate(range.end.date)}`;
    }
    return info;
  }

  if (billingCycle === EPatternUnit.Hour) {
    const startTime = formatTime(range.start.time);
    const endTime = formatTime(range.end.time);
    return `${formatDate(range.start.date)}, ${startTime} - ${endTime}`;
  }

  return "";
};
